import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'
import { useUpdateUserMutation } from '../../../features/fullApi';
import { toast } from 'react-hot-toast';

export default function EditUsernameDialog({openUsernameModal, setOpenUsernameModal, handleUpdateUser}) {
    const user = JSON.parse(localStorage.getItem('user'))
    const [updateUser] = useUpdateUserMutation()


    const onSubmit = async(values, actions) => {
      console.log("CALLED ON SUBMIT")
          updateUser({_id: user._id, username: values.username }, { 
          headers: {
              'Token': `Bearer ${user?.accessToken}`
          }
          }, {id: user._id})
          .then(res => {
            toast.success('Successfully updated username')
            console.log("res is",res)
          })
          .catch((e) => {
          console.log("e is", e)
          })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          username: user?.username,
        },
        onSubmit,
      });

    return (
        <form onSubmit={handleSubmit} style={{width: '500px'}}>
            <Dialog fullWidth aria-labelledby='dialog-title' onClose={() => setOpenUsernameModal(false)} open={openUsernameModal}>
                <DialogTitle id='dialog-title'>
                    Change username
                </DialogTitle>
                <DialogContent>
                    <TextField
                        id="username"
                        type="text"
                        margin="dense"
                        fullWidth
                        value={values.username}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        label={values.username ? "" : "username"}
                    />
                    {errors.username && touched.username && (
                        <p className="error">{errors.username}</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                            color="secondary"
                            onClick={() => 
                            {
                            toast('Canceled ✖');
                            values.username=user?.username
                            setOpenUsernameModal(false)
                            }
                            }
                            variant="contained"
                        >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => handleUpdateUser({id: user._id, username: values.username})}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}